import * as angular from 'angular';
import * as moment from 'moment';
import { IPopupSettings } from '../../../../../app.common/modules/common/models';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { IRetailerRootScope } from '../../../core/models';
import { MenuService } from '../../menu.service';
import { IMenuListItem } from '../../models';
import { ScheduleService } from '../../schedule.service';

class MenuCardController {
    public static $inject = ['$rootScope', '$scope', '$translate', 'scheduleService', 'popupService', 'menuService', 'notificationService'];

    public item: IMenuListItem;
    public isArchived: boolean;
    public image: string;

    private dateFormat = 'DD MMM YYYY';

    constructor(
        private $rootScope: IRetailerRootScope,
        private $scope: ng.IScope,
        private $translate: angular.translate.ITranslateService,
        private scheduleService: ScheduleService,
        private popupService: PopupService,
        private menuService: MenuService,
        private notificationService: NotificationService
    ) {
    }

    private toShortTime(time: string) {
        const t = moment(time, 'hh:mm:ss');
        return t.isValid() ? t.format('hh:mm A') : '';
    }

    private getImage() {
        return this.menuService.getMenuImageUrl(
            this.item.ImageID.toString(),
            350,
            350
        );
    }

    private async duplicateMenu() {
        try {
            await this.popupService.confirm({
                okTxt: this.$translate.instant('cancel'),
                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                cancelTxt: this.$translate.instant('duplicate'),
                cancelClass: 'btn btn-with-background-icon icon-copy--white btn-success',
                title: this.$translate.instant('duplicate_menu_title'),
                content: this.$translate.instant('duplicate_menu_prompt'),
                invertAction: true,
                classPopup: 'popup--redesign modal360',
            } as IPopupSettings);
        } catch (error) {
            return;
        }

        this.$rootScope.$state.go('app.edit-menu', { id: this.item.ID, duplicate: true });
    }

    private async setArchivedMenu() {
        if (this.isArchived) {
            try {
                await this.popupService.confirm({
                    okTxt: this.$translate.instant('cancel'),
                    okClass: 'btn btn-with-background-icon close-icon--tiny24',
                    cancelTxt: this.$translate.instant('restore'),
                    cancelClass: 'btn btn-with-background-icon icon-time-restore--white btn-success',
                    title: this.$translate.instant('restore_menu_title'),
                    content: this.$translate.instant('restore_menu_prompt'),
                    classPopup: 'popup--redesign modal360',
                    invertAction: true
                } as IPopupSettings);
            } catch (error) {
                return;
            }
        } else {
            try {
                await this.popupService.confirm({
                    okTxt: this.$translate.instant('cancel'),
                    okClass: 'btn btn-with-background-icon close-icon--tiny24',
                    cancelTxt: this.$translate.instant('archive_menu'),
                    cancelClass: 'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                    title: this.$translate.instant('archive_menu_title'),
                    content: this.$translate.instant('archive_menu_prompt'),
                    invertAction: true,
                    classPopup: 'popup--redesign modal360',
                } as IPopupSettings);
            } catch (error) {
                return;
            }
        }

        this.notificationService.showWaitingMessage();
        try {
            await this.menuService.setArchivedMenu(this.item.ID.toString(), !this.isArchived);
            this.notificationService.clearAll();
            this.$scope.$emit('updateData');
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
    }
}

angular.module('naut').component('menuCard', {
    template: require('./menu.card.html'),
    controller: MenuCardController,
    controllerAs: 'vm',
    bindings: {
        item: '<',
        isArchived: '<',
        image: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/menus/components/menu-card/menu.card.component.ts